export default __webpack_public_path__ + "static/media/biketrips.18957bc5.jpg";